const estilo_celulas = {
  styleHeader: {
    backgroundColor: '#f7f8ff',
    borderLeft: '1px dashed rgba(0,0,0,.3)',
    textAlign: 'center',
    borderBottomStyle: 'dashed',
  },
  style: {
    borderLeft: '1px dashed rgba(0,0,0,.3)',
    textAlign: 'center',
    borderBottomStyle: 'dashed',
  }
};

export const cabecalhos = [
  {
    text: 'Status de Movimentação no Estoque',
    value: 'descricao_linha',
    style: {
      backgroundColor: '#f7f8ff',
      border: 0,
      width: '30%',
      minWidth: '430px',
    }
  },
  {
    text: 'Total Skus',
    value: 'qtde_produtos',
    totalizar: true,
    ...estilo_celulas,
  },
  {
    text: 'Total %',
    value: 'percentual',
    ...estilo_celulas,
  },
  {
    text: 'Estoque em {data_final}',
    value: 'estoque_em_preco_custo',
    title: "Estoque em preço de custo",
    totalizar: true,
    ...estilo_celulas,
  },
  {
    text: 'Estoque Ideal em {data_final}',
    value: 'estoque_ideal_em_preco_custo',
    title: "Estoque Ideal em preço de custo",
    totalizar: true,
    ...estilo_celulas,
  },
  {
    text: 'Dif. Estoque - Estoque Ideal',
    value: 'diferenca_em_preco_custo',
    title: "Dif. Estoque em preço de custo - Estoque Ideal em preço de custo",
    totalizar: true,
    ...estilo_celulas,
  },
  {
    text: 'Total de Crescimento',
    value: 'crescimento_em_preco_custo',
    title: "Total de Crescimento em preço de custo",
    totalizar: true,
    ...estilo_celulas,
  },
]
